import styled from 'styled-components';

export const SelectPlanStyles = styled.section`
  margin: 144px auto 24px;
  padding: 0 16px;
  max-width: 540px;
`;

export const SelectPlanButtonStyles = styled.button`
  display: block;
  padding: 11px 60px;
  color: #fff;
  margin: 16px auto 8px;
  width: 100%;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(95.02deg, #d9002f 0%, #7f001c 100%);
`;
